export const iconFontAwesomeDevicesHardwarePlug = (
	<i className="fa-solid fa-plug"></i>
);
